import {
    ConfigurationAccountingUnitModalBasicFormState,
    initialConfigurationAccountingUnitModalBasicFormState
} from '@/modules/configurationModule/detail/accounting/billable/units/components/modal-basic-form/configuration-accounting-billable-units-modal-basic-form.model'
import {
    ConfigurationAccountingUnitCreateRequest,
    ConfigurationAccountingUnitPatchInBatchRequest
} from '@/modules/configurationModule/detail/accounting/billable/units/services/configuration-accounting-billable-unit/configuration-accounting-billable-unit.dto'
import {
    configurationAccountingBillableUnitsService
} from '@/modules/configurationModule/detail/accounting/billable/units/services/configuration-accounting-billable-unit/configuration-accounting-billable-unit.service'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { StrictNullable } from '@/shared/types/app.types'
import { BModal } from 'bootstrap-vue'
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

@Component
export default class UnitsModalBasicForm extends Vue {
    @Ref() readonly unitsModalBasicForm!: BModal
    @Prop(String) readonly actionTitle!: string

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    state: ConfigurationAccountingUnitModalBasicFormState
    constructor() {
        super()
        this.state = initialConfigurationAccountingUnitModalBasicFormState()
    }

    get modelValidated(): boolean {
        const hasErrors = this.$validator.errors.any()
        const isDirty = this.$_someFieldIsDirty(this.fields)
        const nameUnit = !!this.state.accountingUnit.name.length
        const symbolUnit = !!this.state.accountingUnit.symbol.length
        const codeUnit = !!this.state.accountingUnit.code.length
        return !hasErrors && isDirty && nameUnit && symbolUnit && codeUnit
    }

    get isUpdateView(): boolean {
        return !!this.state.accountingUnit.id
    }

    get disabledActive(): boolean {
        return this.state.accountingUnit.isDefault
    }
    get disabledDefault(): boolean {
        return !!this.state.originalAccountingUnit?.isDefault
    }

    /// SERVICE CALLS ///

    private async _addAccountingUnit(
        request: ConfigurationAccountingUnitCreateRequest
    ): Promise<StrictNullable<AccountingUnitResponse>> {
        if (request) {
            const response =
                await this.$_toCallSecure(configurationAccountingBillableUnitsService.create(request))
            if (response) {
                this.$_showToastSuccess(this.$tc('configuration.toastMessages.updated'))
                return response
            }
        }
        return null
    }

    private async _updateAccountingUnit(
        request: ConfigurationAccountingUnitPatchInBatchRequest
    ): Promise<StrictNullable<EntityIdentifierWithErrorResponse[]>> {
        return this.$_toCallSecure(configurationAccountingBillableUnitsService.patch([request]))
    }

    /// FORM OPERATIONS ///

    private _createOperation(): Promise<StrictNullable<AccountingUnitResponse>> {
        const { active, name, code, symbol, isDefault } = this.state.accountingUnit
        return this._addAccountingUnit({ active, name, code, symbol, isDefault })
    }

    private async _updateOperation(): Promise<StrictNullable<EntityIdentifierWithErrorResponse[]>> {
        if (this.state.accountingUnit.id) {
            const { id, active, name, code, symbol, isDefault } = this.state.accountingUnit
            return this._updateAccountingUnit({ id, active, name, code, symbol, isDefault })
        }
        return []
    }

    onDefaultChange(): void {
        if (this.state.accountingUnit.isDefault) {
            this.state.accountingUnit.active = true
        }
    }

    /// MODAL OPERATIONS ///

    async show(accountingUnit: StrictNullable<AccountingUnitResponse>): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAccountingUnitModalBasicFormState()
        if (accountingUnit) {
            const { id, active, name, code, symbol, isDefault } = accountingUnit
            this.state.accountingUnit = { id, active, name, code, symbol, isDefault }
            this.state.originalAccountingUnit = cloneDeep(accountingUnit)
        } else {
            const units = await this.$_toCallSecure(configurationAccountingBillableUnitsService.paginator())
            if (units?.totalElements === 0) {
                this.state.accountingUnit.active = true
                this.state.accountingUnit.isDefault = true
            }
        }
        this.unitsModalBasicForm.show()
    }

    async hide(): Promise<void> {
        this.unitsModalBasicForm.hide()
    }

    async doAction(): Promise<void> {
        if (this.isUpdateView) {
            const updateOperationResponse = await this._updateOperation()
            if (updateOperationResponse && !updateOperationResponse.length) {
                this.$_showToastSuccess(this.$tc('configuration.toastMessages.updated'))
                this.update() // emits an event
                await this.hide()
            }
        } else {
            if (await this._createOperation()) {
                this.create() // emits an event
                await this.hide()
            }
        }
    }
}
